import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';

import { ChevronIconComponent } from '@plugins/client/icons/chevron-icon/chevron-icon.component';

@Component({
  selector: 'plugins-accordion',
  imports: [ChevronIconComponent],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent {
  readonly label = input.required<string>();
  readonly collapsible = input<boolean>(true);
  readonly collapsed = model<boolean>(true);

  onToggle(e: Event): void {
    e.preventDefault();
    e.stopPropagation();

    if (this.collapsible()) {
      this.collapsed.update((c) => !c);
    }
  }
}
